import React from 'react';

function Grid(props) {

    let className = props.container ? "container" : "item";
    className += props.justify ? `justify-${props.justify}` : "";
    className += ` ${props.className ||  ''}`;
    const styles = {
        width: props.width,
        textAlign: props.align,
        flexDirection: props.flexDirection,
        justifyContent: props.justifyContent || "space-around",
        padding: props.padding,
        margin: props.margin,
    };

    return (
        <div id={props.id || ''} className={className} style={Object.assign(styles, props.style)}>
            {props.children}
        </div>
    );
}

export default Grid;